export const MCP_PRODUCT_CAROUSEL = 'mcp-product-carousel'
